import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Table, Button, Input, Row, Col, Badge } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import AdminLayout from 'Components/Admin/AdminLayout';
const API_BASE = process.env.REACT_APP_API_URL || 'https://api.heresmyinfo.com/api';
export default function ProfileTable() {
  const {
    t
  } = useTranslation();
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  useEffect(() => {
    loadProfiles();
  }, []);
  useEffect(() => {
    if (searchQuery.trim()) {
      const filtered = profiles.filter(profile => profile.name?.toLowerCase().includes(searchQuery.toLowerCase()) || profile.id?.toLowerCase().includes(searchQuery.toLowerCase()) || profile.userId?.toLowerCase().includes(searchQuery.toLowerCase()));
      setFilteredProfiles(filtered);
    } else {
      setFilteredProfiles(profiles);
    }
  }, [searchQuery, profiles]);

  const loadProfiles = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE}/database/tables/Profile`);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      setProfiles(data.data || []);
      setError(null);
    } catch (err) {
      console.error('Error loading profiles:', err);
      setError(`Failed to load profiles: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = dateString => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
  };

  const formatAcl = acl => {
    if (!acl || !Array.isArray(acl)) return 'N/A';
    return acl.length > 0 ? acl.join(', ') : 'Empty';
  };

  const profilesToShow = filteredProfiles;
  return <AdminLayout>
            <Helmet>
                <title>{t("Profile Table - Admin - HeresMyInfo.com")}</title>
            </Helmet>

            <div className="container-fluid">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <h4 className="mb-0">{t("Profile Table")}</h4>
                                <div className="d-flex align-items-center">
                                    <Badge color="info" className="mr-2">
                                        {profilesToShow.length}{t("profiles")}</Badge>
                                    <Button color="primary" size="sm" onClick={loadProfiles} disabled={loading}>
                                        {loading ? 'Loading...' : 'Refresh'}
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {error && <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>}

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Input type="text" placeholder={t("Search profiles by name, ID, or userId...")} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
                                    </Col>
                                </Row>

                                {loading ? <div className="text-center py-4">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">{t("Loading...")}</span>
                                        </div>
                                        <p className="mt-2">{t("Loading profiles...")}</p>
                                    </div> : <div className="table-responsive">
                                        <Table striped hover>
                                            <thead>
                                                <tr>
                                                    <th>{t("ID")}</th>
                                                    <th>{t("Name")}</th>
                                                    <th>{t("User ID")}</th>
                                                    <th>{t("Delimiter")}</th>
                                                    <th>{t("Country Code")}</th>
                                                    <th>{t("ACL")}</th>
                                                    <th>{t("Default Card ID")}</th>
                                                    <th>{t("Base62 ID")}</th>
                                                    <th>{t("Created")}</th>
                                                    <th>{t("Updated")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {profilesToShow.map((profile, index) => <tr key={profile.id || index}>
                                                        <td>
                                                            <code className="small">{profile.id}</code>
                                                        </td>
                                                        <td>
                                                            <strong>{profile.name || 'N/A'}</strong>
                                                        </td>
                                                        <td>
                                                            <code className="small">{profile.userId}</code>
                                                        </td>
                                                        <td>{profile.delimiter || 'N/A'}</td>
                                                        <td>{profile.countryCode || 'N/A'}</td>
                                                        <td>
                                                            <small className="text-muted">
                                                                {formatAcl(profile.acl)}
                                                            </small>
                                                        </td>
                                                        <td>
                                                            <code className="small">{profile.defaultCardId || 'N/A'}</code>
                                                        </td>
                                                        <td>
                                                            <code className="small">{profile.base62Id || 'N/A'}</code>
                                                        </td>
                                                        <td>
                                                            <small>{formatDate(profile.createdAt)}</small>
                                                        </td>
                                                        <td>
                                                            <small>{formatDate(profile.updatedAt)}</small>
                                                        </td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>}

                                {!loading && profilesToShow.length === 0 && <div className="text-center py-4">
                                        <p className="text-muted">
                                            {searchQuery ? 'No profiles found matching your search.' : 'No profiles found.'}
                                        </p>
                                    </div>}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </AdminLayout>;
}